import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { GridFormItem } from '../../../core/components/sections'

import { usePriorityTaskProgressCountsLazyQuery } from '../../../priority-tasks/hooks'

const MenuCurationTasksPriorityTaskProgressCounts = ({ isDisabled }) => {
  const [fetchCounts, { data: progressCounts }] =
    usePriorityTaskProgressCountsLazyQuery()

  useEffect(() => {
    if (!isDisabled) {
      fetchCounts()
    }
  }, [fetchCounts, isDisabled])

  if (isDisabled || !progressCounts) {
    return null
  }

  return (
    <GridFormItem span={4} label="Priority Task Progress">
      {progressCounts?.doneCount}/{progressCounts?.allocatedDishCount}
    </GridFormItem>
  )
}

MenuCurationTasksPriorityTaskProgressCounts.propTypes = {
  isDisabled: PropTypes.bool,
}

MenuCurationTasksPriorityTaskProgressCounts.defaultProps = {
  isDisabled: false,
}

export default MenuCurationTasksPriorityTaskProgressCounts
